// Core
import React, { useEffect } from 'react';
import { Box, Button, Flex, Text, Divider, Grid, Image, useColorMode } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import { ReactComponent as Apple } from 'assets/svg/applestore.svg';
import { ReactComponent as Android } from 'assets/svg/playmarket.svg';
import screen1 from 'assets/img/details/screen-7.png';
import screen2 from 'assets/img/details/screen-8.png';
import screen1White from 'assets/img/details/screen-7-white.png';
import screen2White from 'assets/img/details/screen-8-white.png';
import crystal from 'assets/img/details/crystal-3.png';

// Components
import Card from 'components/Card/Card';

const RewardsClub = ({ deviceType }) => {
	const android = 'https://play.google.com/store/apps/details?id=com.lmctmembers';
	const ios = 'https://apps.apple.com/au/app/lmct/id1621538736';

	const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

	useEffect(() => {
	    if(deviceType === 'Android'){
	    	window.location.href = android;
	    } else if(deviceType === 'iOS'){
	    	window.location.href = ios;
	    }
	}, [deviceType]);

    return (
    	<Box pt="100px" mt="-100px" overflow="hidden" borderRadius="16px" className="animation-rewards-club">
	        <Card padding="0px" borderWidth="0">
	        	<Grid templateColumns={{ sm: '1fr', md: '1fr 0.8fr' }} gap="0px" templateRows='1fr'>
	        		<Box overflow="hidden" position="relative" zIndex="8">
	        			<Box p="16px" zIndex="2" position="relative">
		        			<Text variant="header" fontStyle="normal" fontSize={{base: '36px', sm: '48px'}}>One-touch</Text>
		        			<Text variant="header-gradient" fontStyle="normal" fontSize={{base: '36px', sm: '48px'}} mt="-2px">convenience!</Text>

		        			<Text maxW={{sm: '100%', md: '70%'}} mt="17px">
		        				Download and get instant access to all features directly 
								from your phone — no need for a computer. Participate in events, 
		        				stay updated, and do everything you need anytime, anywhere. 
		        				All you need is your smartphone and one tap!
		        			</Text>

		        			<Box maxW={{sm: '100%', md: '79%'}}>
		        			<Grid templateColumns={{ sm: '1fr', lg: '1fr 1fr' }} gap="13px" templateRows='1fr' mt={{base: '16px', md: '72px'}}>
		        				<a href={android}>
			        				<Button variant={ isDark ? 'button-lg-g' : 'button-lg'} h="62px">
			        					<Flex gap="9px">
			        						<Android />
			        						<Box textAlign="left">
			        							<Text variant="text-xs" color="white" fontWeight="500" textTransform="uppercase">Get it on</Text>
			        							<Text variant="title-lg" fontWeight="700" fontSize="20px" style={ !isDark ? {color: 'white'} : {}}>Google play</Text>
			        						</Box>
			        					</Flex>
			        				</Button>
		        				</a>

		        				<a href={ios}>
			        				<Button variant={ isDark ? 'button-lg-g' : 'button-lg'} h="62px">
			        					<Flex gap="9px">
			        						<Apple />
			        						<Box textAlign="left">
			        							<Text variant="text-xs" color="white" fontWeight="500" textTransform="uppercase">Dowload on the</Text>
			        							<Text variant="title-lg" fontWeight="700" fontSize="20px" style={ !isDark ? {color: 'white'} : {}}>App Store</Text>
			        						</Box>
			        					</Flex>
			        				</Button>
		        				</a>
		        			</Grid>
		        			</Box>
	        			</Box>
	        			{ isDark ? (
	        				<Lines className="abstract-lines" style={{ zIndex: 1, top: '-169px', transform: 'rotate(-36deg) scale(1)', left: '-21%' }} />
	        			) : (
	        				<LinesWhite className="abstract-lines" style={{ zIndex: 1, top: '-169px', transform: 'rotate(-36deg) scale(1)', left: '-21%', opacity: 0.3 }} />
	        			)}
	        		</Box>

	        		<Box h={{base: '270px', md: 'unset'}}>
	        			<Image src={crystal} alt="crystal" className="animation-rewards-club-crystal1" position="absolute" w="360px" right="310px" bottom="-50px" transform="rotate(350deg)" />
	        			<Image src={ isDark ? screen1 : screen1White } alt="screen" className="animation-rewards-club-phone1" position="absolute" w={{base: '407px', md: '545px'}} top={{base: 'unset', md: '-92px'}} bottom={{base: '-210px', md: 'unset'}} zIndex="2" right="152px" />
	        			<Image src={ isDark ? screen2 : screen2White } alt="screen" className="animation-rewards-club-phone2" position="absolute" w={{base: '307px', md: '357px'}} right="-32px" zIndex="1" top={{base: 'unset', md: '-80px'}} bottom={{base: '-200px', md: 'unset'}} />
	        			<Image src={crystal} alt="crystal" className="animation-rewards-club-crystal2" position="absolute" zIndex="4" transform="rotate(32deg)" bottom="-75px" width="260px" right="120px" />
	        			<Box mt="0px" borderRadius="16px" overflow="hidden" position="relative" w="200%" h="100%" right="100%">
	        				{ isDark && <Box className="animation-rewards-club-gradient" bg="#099BFF" zIndex="0" filter="blur(100px)" borderRadius="100%" m="0 auto" w="35%" right="90px" top="80px" h="270px" position="absolute" />}
	        			</Box>
	        		</Box>
	        	</Grid>
	        </Card>
        </Box>
    );
};


export default RewardsClub;